export const DEFAULT_CONNECTION_CREATION = Object.freeze({
    line_width: 3,
    corner_radius: 8,
    animation_enabled: true,
    bullet_size: 5,
    bullet_count: 3,
})

export function normalizeConnectionCreationDefaults(value = {}) {
    const width = Number(value?.line_width)
    const radius = Number(value?.corner_radius)
    const bulletSize = Number(value?.bullet_size)
    const bulletCount = Number(value?.bullet_count)
    return {
        line_width: Number.isFinite(width) && width >= 1 ? width : DEFAULT_CONNECTION_CREATION.line_width,
        corner_radius: Number.isFinite(radius) && radius >= 0 ? radius : DEFAULT_CONNECTION_CREATION.corner_radius,
        animation_enabled: value?.animation_enabled !== false,
        bullet_size: Number.isFinite(bulletSize) && bulletSize > 0 ? bulletSize : DEFAULT_CONNECTION_CREATION.bullet_size,
        bullet_count: Number.isFinite(bulletCount) && bulletCount >= 1
            ? Math.round(bulletCount) : DEFAULT_CONNECTION_CREATION.bullet_count,
    }
}

export function resolvedSourceConnectionColor(sourceBadge) {
    return sourceBadge?.styleProp?.('main', 'border_color') || '#ffffffff'
}
